import { api } from "../utils/api";
import type { StoreId, CreditNoteId } from "@KassaroAB/shared/types/ids";
import type { RestCreditNote, RestCreateCreditNote, RestUpdateCreditNote } from "@KassaroAB/shared/types/creditNote";

export const getCreditNotesApi = async (
  storeId: StoreId,
): Promise<RestCreditNote[]> => {
  return api.get(`stores/${storeId}/creditNotes`);
};

export const getCreditNoteApi = async (
  storeId: StoreId,
  creditNoteId: CreditNoteId,
): Promise<RestCreditNote> => {
  return api.get(`stores/${storeId}/creditNotes/${creditNoteId}`);
};

export const createCreditNoteApi = async (
  storeId: StoreId,
  creditNote: RestCreateCreditNote,
): Promise<RestCreditNote> => {
  return api.post(`stores/${storeId}/creditNotes`, creditNote);
};

export const updateCreditNoteApi = async (
  storeId: StoreId,
  creditNoteId: CreditNoteId,
  creditNote: RestUpdateCreditNote,
): Promise<RestCreditNote> => {
  return api.put(`stores/${storeId}/creditNotes/${creditNoteId}`, creditNote);
};

export const deleteCreditNoteApi = async (
  storeId: StoreId,
  creditNoteId: CreditNoteId,
): Promise<void> => {
  return api.delete(`stores/${storeId}/creditNotes/${creditNoteId}`);
};
